// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"2c388149","315":"1f798728","417":"b0046bca","488":"5b39e09c","513":"470598a1","534":"6b31c299","782":"fc982956"}[chunkId] + ".chunk.js";
};